import { useState } from 'react';
import '../styles/Home.css';

const Youth = () => {

  return (

    <div className="container">

      <div>

      </div>

      <div className="row">
        <h4 className="center-align"><b >MCIA's Youth Volunteering Program</b></h4>
      </div>

      <div>
        <h2 className="fbt-title"><img src="/images/volunteer/volunteer.jpg" alt="" width="80%" className="rounded" />  </h2>
        <p >&nbsp;</p>
        <h5 >McLean County India Association (MCIA) invites youth (6th grade and above) to come forward and register to be MCIA’s youth volunteer and avail yearlong volunteer opportunities. Hours spent on eligible events are counted towards the individual’s school district volunteer/community service hours. Please fill the below form if you are interested.</h5>
      </div>

      <p >&nbsp;</p>
      <div className="row">

        <h5 className="center-align"><a type="button" class="btn btn-primary btn-lg" href="https://chat.whatsapp.com/FQEfOk3qmD5Btua3wlkNcg">Join Youth Volunteering Whatsapp Group</a></h5>
      </div>

      <h4 className="center-align"><b >Note that you need to be a member to take advantage of this facility.</b></h4>
      <h5 className="center-align">Membership registration into MCIA is open all year long for a nominal fee of $30. Check "Membership" tab or contact any of our volunteers for more details.</h5>
      <p >&nbsp;</p>
      <h4 className="center-align">Kids will get to participate and volunteer in below activities.</h4>
      <p >&nbsp;</p>
      <div className="row">

        <ul>
          <li className="list-unstyled"><h5 className="center-align"><b ><u >2025 Major Events</u></b></h5></li>
          <li className="bullet"><h5 >Men's doubles and Mixed doubles shuttle badminton Tournament</h5></li>
          <li className="bullet"><h5 >Kids & Adults Talent Show</h5></li>
          <li className="bullet"><h5 >5K Run </h5></li>
          <li className="bullet"><h5 >Indian Independence Day</h5></li>
          <li className="bullet"><h5 >Festival of India</h5></li>
          <li className="bullet"><h5 >Annual Banquet</h5></li>
          <li className="bullet"><h5 >Youth Open House</h5></li>
          <li className="bullet"><h5 >Toastmasters Youth Leadership Program</h5></li>
        </ul>

      </div>

      <div className="row">

        <ul>
          <li className="list-unstyled"><h5 className="center-align"><b ><u >Community Serving Opportunities</u></b></h5></li>
          <li className="bullet"><h5 >Mission Mart</h5></li>
          <li className="bullet"><h5 >College Avenue Cleanup</h5></li>
          <li className="bullet"><h5 >5K Run</h5></li>
          <li className="bullet"><h5 >YWCA Volunteering</h5></li>
          <li className="bullet"><h5 >Midwest Food Bank</h5></li>
          <li className="bullet"><h5 >Red Cross Volunteering Activities </h5></li>
          <li className="bullet"><h5 >Salvation Army Volunteering</h5></li>
          <li className="bullet"><h5 >Home Sweet Home Mission</h5></li>
          <li className="bullet"><h5 >Back to School</h5></li>
          <li className="bullet"><h5 >Special Olympics</h5></li>
        </ul>

      </div>

      <div className="row">

        <ul>
          <li className="list-unstyled"><h5 className="center-align"><b ><u >SEMINARS</u></b></h5></li>
          <li className="bullet"><h5 >Living WILL</h5></li>
          <li className="bullet"><h5 >College Admission and scholarships</h5></li>
          <li className="bullet"><h5 >Life Insurance</h5></li>
          <li className="bullet"><h5 >SSN & Medicare</h5></li>
          <li className="bullet"><h5 >Emergency Services(Police, Fire department)</h5></li>
        </ul>

      </div>

      <div><hr class="hr-line"></hr></div>

    </div>



  );
}
export default Youth;
